import { format } from 'date-fns';
import { Filters, SchemaFilterType, SchemaProps } from '../types';

export default function transformValueForUrl(
  filterValues: Filters,
  currentSchemaValues: SchemaProps,
) {
  const transformedValuesForURL: Record<string, any> = {};

  Object.entries(filterValues).forEach(([key, filterValue]) => {
    if (
      filterValue !== undefined &&
      (currentSchemaValues) &&
      (currentSchemaValues)[key] &&
      (currentSchemaValues)[key]?.value?.encode(filterValue) !==
        undefined
    ) {
      if (
        (currentSchemaValues)[key].type ===
        SchemaFilterType.DATE_RANGE
      ) {
        const queryNames = (currentSchemaValues)[key]
          ?.queryNames;

        const withTimeSelector = (currentSchemaValues)[key]
          ?.withTimeSelector;

        // eslint-disable-next-line no-unsafe-optional-chaining
        const [from, to] = filterValue?.value;

        if (from) {
          if (!withTimeSelector) {
            transformedValuesForURL[queryNames ? queryNames[0] : `${key}From`] =
              format(new Date(from), 'yyyy-MM-dd');
          } else {
            transformedValuesForURL[queryNames ? queryNames[0] : `${key}From`] =
              format(new Date(from), 'yyyy-MM-dd HH:mm:ss');
          }
        }
        if (filterValue.value.length > 1) {
          if (!withTimeSelector) {
            transformedValuesForURL[queryNames ? queryNames[1] : `${key}To`] =
              format(new Date(to), 'yyyy-MM-dd');
          } else {
            transformedValuesForURL[queryNames ? queryNames[1] : `${key}To`] =
              format(new Date(to), 'yyyy-MM-dd HH:mm:ss');
          }
        }
      } else if (
        (currentSchemaValues)[key].type === SchemaFilterType.DATE
      ) {
        const [date] = filterValue.value;

        if (date) {
          transformedValuesForURL[key] = format(new Date(date), 'yyyy-MM-dd');
        }
      } else {
        transformedValuesForURL[key] = filterValue.value;
      }
    }
  });

  return transformedValuesForURL;
}
